import {
  UserPaymentDetailsFetchTypeProps,
  UseUserPaymentDetailsMeProps,
  UseUserPaymentDetailsReturnType,
} from './props';
import { useUserPaymentDetailsMeDefault } from './useUserPaymentDetailsMeDefault';
import { useUserPaymentDetailsMeInfinity } from './useUserPaymentDetailsMeInfinity';

export function useUserPaymentDetailsMe<
  T extends UserPaymentDetailsFetchTypeProps | undefined,
>({
  type,
  enabled = true,
  paymentType,
}: UseUserPaymentDetailsMeProps<T>): UseUserPaymentDetailsReturnType<T> {
  const useUserPaymentDetailsMeInfinite = useUserPaymentDetailsMeInfinity({
    type,
    paymentType,
    enabled: enabled && type === 'infinity',
  });
  const useUserPaymentDetailsMeDefaultQuery = useUserPaymentDetailsMeDefault({
    type,
    paymentType,
    enabled: enabled && type === 'default',
  });

  if (type == 'infinity') {
    return useUserPaymentDetailsMeInfinite as UseUserPaymentDetailsReturnType<T>;
  }

  return useUserPaymentDetailsMeDefaultQuery as UseUserPaymentDetailsReturnType<T>;
}
